import { Box, Typography } from "@mui/material";
import { colors } from "../../ui/colors";

export const PasswordStrengthChecker = ({ password }) => {
  const checks = [
    { label: "At least 8 characters", valid: password.length >= 8 },
    { label: "Contains uppercase letter", valid: /[A-Z]/.test(password) },
    { label: "Contains special character", valid: /[!@#$%^&*(),.?":{}|<>_\-]/.test(password) },
    { label: "Contains number", valid: /\d/.test(password) },
    { label: "No consecutive numbers", valid: !/012|123|234|345|456|567|678|789/.test(password) },
  ];

  const validChecks = checks.filter(check => check.valid).length;

  const getStrengthInfo = () => {
    if (validChecks <= 2) {
      return { label: "Low", color: colors.danger.base };
    }
    if (validChecks <= 4) {
      return { label: "Medium", color: colors.warning.base };
    }
    return { label: "Strong", color: colors.success.base };
  };

  const strengthInfo = getStrengthInfo();

  if (!password) return null;

  return (
    <Box sx={{ mt: 1 }}>
      {/* Indicador de seguridad */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: colors.gray[500],
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          Password strength:
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: strengthInfo.color,
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "uppercase",
          }}
        >
          {strengthInfo.label}
        </Typography>
        <Box
          sx={{
            width: 40,
            height: 4,
            borderRadius: 2,
            backgroundColor: strengthInfo.color,
            ml: 0.5,
          }}
        />
      </Box>

      {/* Lista */}
      {checks.map((check, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            py: 0.5,
          }}
        >
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              backgroundColor: check.valid ? colors.success.base : colors.gray[300],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            {check.valid && (
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
                }}
              />
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: check.valid ? colors.gray.base : colors.gray[400],
              fontSize: "13px",
              fontWeight: check.valid ? 500 : 400,
              transition: "all 0.2s ease",
            }}
          >
            {check.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};